/**
 * Intelligems A/B — hide US sizes 4, 5, 6 (control)
 *
 * Control (default): sizes 4 / 5 / 6 hidden; first visible size (e.g. US 7) auto-selected.
 * Group 1: <body data-ig-show-size-456="true"> — all sizes visible; US 4 stays default.
 *
 * Intelligems inject (Group 1):
 *   document.body.setAttribute('data-ig-show-size-456', 'true');
 *
 * Excluded PDPs (e.g. /products/soft-slides) never hide small sizes
 * and default to the first available size instead of US 7 / US 4.
 */
(function () {
  'use strict';

  if (window.__igHideSmallSizesBooted) return;
  window.__igHideSmallSizesBooted = true;

  var ATTR = 'data-ig-show-size-456';
  var HIDDEN_NUMBERS = ['4', '5', '6'];
  var HIDDEN_CLASS = 'ig-ab-hidden-size';
  var STYLE_ID = 'ig-hide-small-sizes-ab-styles';
  var MARK = 'data-ig-ab-size-managed';
  var EXCLUDED_HANDLES = ['soft-slides'];

  function getProductHandle() {
    var path = window.location.pathname || '';
    var match = path.match(/\/products\/([^/?#]+)/i);
    return match ? decodeURIComponent(match[1]).toLowerCase() : '';
  }

  function isExcludedProduct() {
    return EXCLUDED_HANDLES.indexOf(getProductHandle()) !== -1;
  }

  var DEFAULT_GROUP1_NUMBER = '4';
  var applying = false;
  var debounceTimer;
  var lastHideMode = null;
  var group1DefaultApplied = Object.create(null);
  var userChangedSize = Object.create(null);

  function isShowSizesEnabled() {
    var value = (document.body.getAttribute(ATTR) || '').trim().toLowerCase();
    return value === 'true' || value === '1' || value === 'on' || value === 'yes';
  }

  function parseSizeNumber(value) {
    if (value == null) return null;
    var text = String(value).trim();
    var match = text.match(/(?:US\s*)?(\d+(?:\.\d+)?)/i);
    return match ? match[1] : null;
  }

  function shouldHideSizeValue(value) {
    var num = parseSizeNumber(value);
    if (!num) return false;
    return HIDDEN_NUMBERS.indexOf(num) !== -1;
  }

  function isDefaultGroup1Size(value) {
    return parseSizeNumber(value) === DEFAULT_GROUP1_NUMBER;
  }

  function getVariantSelectsKey(variantSelects) {
    return (
      variantSelects.id ||
      variantSelects.getAttribute('data-section') ||
      'default'
    );
  }

  function resetGroup1Defaults() {
    group1DefaultApplied = Object.create(null);
    userChangedSize = Object.create(null);
  }

  function injectStyles() {
    if (document.getElementById(STYLE_ID)) return;
    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent =
      '.' +
      HIDDEN_CLASS +
      '{display:none!important;}' +
      'option.' +
      HIDDEN_CLASS +
      '{display:none;}';
    document.head.appendChild(style);
  }

  function isSizeOptionRow(row) {
    if (!row) return false;

    var label = row.querySelector('.form__label');
    if (label && /size/i.test(label.textContent || '')) return true;

    var select = row.querySelector('select.select__select');
    if (!select) return false;

    var options = select.querySelectorAll('option');
    if (!options.length) return false;

    var sizeLike = 0;
    for (var i = 0; i < options.length; i++) {
      if (parseSizeNumber(options[i].value)) sizeLike++;
    }
    return sizeLike >= Math.max(1, Math.ceil(options.length * 0.5));
  }

  function rememberDisabled(el) {
    if (!el.hasAttribute(MARK)) {
      el.setAttribute(MARK, el.disabled ? '1' : '0');
    }
  }

  function restoreDisabled(el) {
    if (!el.hasAttribute(MARK)) return;
    el.disabled = el.getAttribute(MARK) === '1';
    el.removeAttribute(MARK);
  }

  function hideManaged(el) {
    rememberDisabled(el);
    el.classList.add(HIDDEN_CLASS);
    el.setAttribute('aria-hidden', 'true');
    if ('disabled' in el) el.disabled = true;
  }

  function showManaged(el) {
    el.classList.remove(HIDDEN_CLASS);
    el.removeAttribute('aria-hidden');
    restoreDisabled(el);
  }

  function hideSelectOption(option) {
    rememberDisabled(option);
    option.classList.add(HIDDEN_CLASS);
    option.hidden = true;
    option.disabled = true;
  }

  function showSelectOption(option) {
    option.classList.remove(HIDDEN_CLASS);
    option.hidden = false;
    restoreDisabled(option);
  }

  function hidePillButton(btn) {
    hideManaged(btn);
  }

  function hideRadioOption(radio) {
    hideManaged(radio);
    var label = document.querySelector('label[for="' + CSS.escape(radio.id) + '"]');
    if (label) hideManaged(label);
  }

  function showRadioOption(radio) {
    showManaged(radio);
    var label = document.querySelector('label[for="' + CSS.escape(radio.id) + '"]');
    if (label) showManaged(label);
  }

  function optionIsSelectable(option, hideMode) {
    return (
      option &&
      option.value &&
      !option.disabled &&
      !option.hidden &&
      !option.classList.contains(HIDDEN_CLASS) &&
      (!hideMode || !shouldHideSizeValue(option.value))
    );
  }

  function getSelectOption(select, value) {
    if (!select || value == null) return null;
    var options = select.options || select.querySelectorAll('option');
    for (var i = 0; i < options.length; i++) {
      if (options[i].value === value) return options[i];
    }
    return null;
  }

  function fixSelectSelection(select, hideMode) {
    if (!select || !hideMode) return false;

    var currentOption = getSelectOption(select, select.value);
    if (optionIsSelectable(currentOption, hideMode)) return false;

    var options = select.querySelectorAll('option');
    for (var i = 0; i < options.length; i++) {
      if (!optionIsSelectable(options[i], hideMode)) continue;
      if (select.value === options[i].value) return false;
      select.value = options[i].value;
      select.dispatchEvent(new Event('change', { bubbles: true }));
      return true;
    }
    return false;
  }

  function fixRadioSelection(row, hideMode) {
    if (!hideMode) return false;

    var checked = row.querySelector('input[type="radio"]:checked');
    if (checked && !checked.classList.contains(HIDDEN_CLASS) && !shouldHideSizeValue(checked.value)) {
      return false;
    }

    var radios = row.querySelectorAll('input[type="radio"]');
    for (var i = 0; i < radios.length; i++) {
      var radio = radios[i];
      if (radio.classList.contains(HIDDEN_CLASS)) continue;
      if (shouldHideSizeValue(radio.value)) continue;
      if (radio.disabled || radio.classList.contains('disabled')) continue;
      if (checked === radio) return false;
      radio.checked = true;
      radio.dispatchEvent(new Event('change', { bubbles: true }));
      return true;
    }
    return false;
  }

  function findDefaultGroup1Option(select) {
    var options = select.querySelectorAll('option');
    for (var i = 0; i < options.length; i++) {
      if (isDefaultGroup1Size(options[i].value) && optionIsSelectable(options[i], false)) {
        return options[i];
      }
    }
    return null;
  }

  function selectDefaultGroup1(select, row) {
    if (select) {
      var target = findDefaultGroup1Option(select);
      if (!target || select.value === target.value) return false;
      select.value = target.value;
      select.dispatchEvent(new Event('change', { bubbles: true }));
      return true;
    }

    var radios = row.querySelectorAll('input[type="radio"]');
    for (var i = 0; i < radios.length; i++) {
      var radio = radios[i];
      if (!isDefaultGroup1Size(radio.value)) continue;
      if (radio.disabled || radio.classList.contains('disabled')) continue;
      if (radio.checked) return false;
      radio.checked = true;
      radio.dispatchEvent(new Event('change', { bubbles: true }));
      return true;
    }
    return false;
  }

  function findFirstSelectableOption(select) {
    var options = select.querySelectorAll('option');
    for (var i = 0; i < options.length; i++) {
      if (optionIsSelectable(options[i], false)) return options[i];
    }
    return null;
  }

  function selectFirstAvailableSize(select, row) {
    if (select) {
      var target = findFirstSelectableOption(select);
      if (!target || select.value === target.value) return false;
      select.value = target.value;
      select.dispatchEvent(new Event('change', { bubbles: true }));
      return true;
    }

    var radios = row.querySelectorAll('input[type="radio"]');
    for (var i = 0; i < radios.length; i++) {
      var radio = radios[i];
      if (!radio.value) continue;
      if (radio.classList.contains(HIDDEN_CLASS)) continue;
      if (radio.disabled || radio.classList.contains('disabled')) continue;
      if (radio.checked) return false;
      radio.checked = true;
      radio.dispatchEvent(new Event('change', { bubbles: true }));
      return true;
    }
    return false;
  }

  function applyToRow(row, hideMode, variantSelectsKey) {
    if (!isSizeOptionRow(row)) return false;

    var changed = false;
    var select = row.querySelector('select.select__select');

    if (select) {
      var options = select.querySelectorAll('option');
      for (var i = 0; i < options.length; i++) {
        var opt = options[i];
        if (!opt.value) continue;
        if (hideMode && shouldHideSizeValue(opt.value)) hideSelectOption(opt);
        else showSelectOption(opt);
      }
      if (fixSelectSelection(select, hideMode)) changed = true;
    }

    row.querySelectorAll('input[type="radio"]').forEach(function (radio) {
      if (!radio.value) return;
      if (hideMode && shouldHideSizeValue(radio.value)) hideRadioOption(radio);
      else showRadioOption(radio);
    });

    row.querySelectorAll('.ig-variant-pills__btn').forEach(function (btn) {
      var val = btn.getAttribute('data-value');
      if (val == null) return;
      if (hideMode && shouldHideSizeValue(val)) hidePillButton(btn);
      else showManaged(btn);
    });

    if (!select && fixRadioSelection(row, hideMode)) changed = true;

    if (isExcludedProduct() && !userChangedSize[variantSelectsKey]) {
      if (selectFirstAvailableSize(select, row)) changed = true;
    } else if (
      !hideMode &&
      !isExcludedProduct() &&
      !userChangedSize[variantSelectsKey] &&
      !group1DefaultApplied[variantSelectsKey]
    ) {
      if (selectDefaultGroup1(select, row)) changed = true;
      group1DefaultApplied[variantSelectsKey] = true;
    }

    return changed;
  }

  function applyAll() {
    if (applying) return;
    applying = true;

    try {
      var hideMode = !isShowSizesEnabled() && !isExcludedProduct();

      if (lastHideMode === true && hideMode === false) {
        resetGroup1Defaults();
      }
      lastHideMode = hideMode;

      document.body.classList.toggle('ig-ab-hide-size-456', hideMode);
      document.body.classList.toggle('ig-ab-show-size-456', !hideMode);

      var anyChanged = false;
      document.querySelectorAll('variant-selects').forEach(function (variantSelects) {
        var key = getVariantSelectsKey(variantSelects);
        variantSelects.querySelectorAll('.product-form__input').forEach(function (row) {
          if (applyToRow(row, hideMode, key)) anyChanged = true;
        });
      });

      if (anyChanged) {
        document.dispatchEvent(new CustomEvent('variant:change'));
      }
    } finally {
      applying = false;
    }
  }

  function scheduleApply() {
    if (debounceTimer) clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function () {
      requestAnimationFrame(applyAll);
    }, 30);
  }

  function boot() {
    injectStyles();
    applyAll();
    setTimeout(applyAll, 200);
    setTimeout(applyAll, 700);
    setTimeout(applyAll, 1400);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', scheduleApply);
  document.addEventListener('variant:change', scheduleApply);

  document.addEventListener(
    'change',
    function (event) {
      if (applying) return;
      var target = event.target;
      if (!target) return;

      var isSizeInput =
        (target.matches && target.matches('select.select__select')) ||
        (target.matches && target.matches('input[type="radio"]'));
      if (!isSizeInput) return;

      var row = target.closest('.product-form__input');
      if (!row || !isSizeOptionRow(row)) return;

      var variantSelects = target.closest('variant-selects');
      if (!variantSelects) return;

      userChangedSize[getVariantSelectsKey(variantSelects)] = true;
    },
    true
  );

  new MutationObserver(scheduleApply).observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: [ATTR],
  });

  window.IgHideSmallSizes = {
    enable: function () {
      resetGroup1Defaults();
      document.body.setAttribute(ATTR, 'true');
      applyAll();
    },
    disable: function () {
      document.body.removeAttribute(ATTR);
      applyAll();
    },
    apply: applyAll,
    isShowEnabled: isShowSizesEnabled,
  };
})();
